import Title from "src/components/Title";
import JobAnalysisPageReport from "./JobAnalysisPageReport";
import Button from "src/components/Button";
import Progressbar from "src/components/Progressbar";
import { useContext } from "react";
import userContext from "src/context/userContext";
import { post } from "src/services/HttpClient";
import { useLocation } from "react-router-dom";
import { getAllLocalStorageData } from "src/utils/getAllLocalStorageData";

export default function JobAnalysisPageFinish({ handleStep, jobReload }) {
  const { user } = useContext(userContext)
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const jobId = params.get("id");




  return (
    <>
      {/* <PanelLayout> */}


      <JobAnalysisPageReport jobReload={jobReload} />
      {/* <div className="w-[1100px] flex justify-center flex-col m-auto mt-10">
        <Title title="گزارش نهایی" />
        <Progressbar activePart={null} handleStep={handleStep} />
      </div> */}
      {/* <div className="flex gap-2 justify-center items-center relative mb-10 z-50">
        <Button title="ثبت اطلاعات و بازگشت به ابتدا" direction="center" />
      </div> */}
      {/* </PanelLayout> */}
    </>

  )
}